import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "form-label text-capitalize-first" }
const _hoisted_3 = ["disabled", "value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "form-label text-capitalize-first" }
const _hoisted_8 = ["disabled", "value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "form-label text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TraderMultiselect = _resolveComponent("TraderMultiselect")!
  const _component_MerchantMultiselect = _resolveComponent("MerchantMultiselect")!
  const _component_MerchantTgGroupMultiselect = _resolveComponent("MerchantTgGroupMultiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.traders')), 1),
      _createElementVNode("select", {
        class: "form-select form-select-sm",
        disabled: _ctx.disabled,
        value: _ctx.modelValue.traderScope,
        onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onTraderScopeChange($event)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.traderScopes, (scope) => {
          return (_openBlock(), _createElementBlock("option", {
            key: scope,
            value: scope
          }, _toDisplayString(_ctx.helper.trans(`notification_center.trader_scope.${scope}`)), 9, _hoisted_4))
        }), 128))
      ], 40, _hoisted_3),
      (_ctx.modelValue.traderScope === 'selected')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_TraderMultiselect, {
              disabled: _ctx.disabled,
              multiple: true,
              small: true,
              modelValue: _ctx.selectedTraders,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedTraders) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.merchants')), 1),
      _createElementVNode("select", {
        class: "form-select form-select-sm",
        disabled: _ctx.disabled,
        value: _ctx.modelValue.merchantScope,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onMerchantScopeChange($event)))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.merchantScopes, (scope) => {
          return (_openBlock(), _createElementBlock("option", {
            key: scope,
            value: scope
          }, _toDisplayString(_ctx.helper.trans(`notification_center.merchant_scope.${scope}`)), 9, _hoisted_9))
        }), 128))
      ], 40, _hoisted_8),
      (_ctx.modelValue.merchantScope === 'selected')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createVNode(_component_MerchantMultiselect, {
              disabled: _ctx.disabled,
              multiple: true,
              small: true,
              modelValue: _ctx.selectedMerchants,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedMerchants) = $event))
            }, null, 8, ["disabled", "modelValue"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.helper.trans('notification_center.merchant_tg_groups')), 1),
      _createVNode(_component_MerchantTgGroupMultiselect, {
        disabled: _ctx.disabled,
        modelValue: _ctx.selectedMerchantGroups,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedMerchantGroups) = $event))
      }, null, 8, ["disabled", "modelValue"])
    ])
  ]))
}